import axios from "axios";
import swal from "sweetalert";
import router from "@/router";
import { errorMessage, tokenExpired } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {
    token: null,
    userLoggedIn: null,
    userDepartment: null,
    number: 0,
    keyRefresh: 0,
    infoDepartment: null,
    refreshCounter: 0
  },
  getters: {
    showUserLoggedIn(state) {
      return state.userLoggedIn;
    },
    showUserDepartment(state) {
      return state.userDepartment;
    },
    showInfoDepartment(state) {
      return state.infoDepartment;
    }
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUserLoggedIn(state, userLoggedIn) {
      state.userLoggedIn = userLoggedIn;
    },
    setUserDepartment(state, newUserDepartment) {
      state.userDepartment = newUserDepartment;
    },
    setInfoDepartment(state, newInfoDepartment) {
      state.infoDepartment = newInfoDepartment;
    },
    setNumber(state) {
      state.number += 1;
    },
    setKeyRefresh(state) {
      state.keyRefresh += 1;
    },
    setRefreshCounter(state) {
      state.refreshCounter += 1;
    }
  },
  actions: {
    async login({ commit, dispatch }, login) {
      let body = `grant_type=&username=${login.username}&password=${login.password}&scope=&client_id=&client_secret=`;
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE + `/api/auth/access-token/`,
          body,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            }
          }
        );
        let userInfo;
        let loginInfo = JSON.parse(
          localStorage.getItem("charlie-username-otr")
        );
        let currentDepartment;
        if (response.status == 200) {
          let departmentAccess = response.data.department;
          departmentAccess.forEach(department => {
            if (
              loginInfo &&
              loginInfo[0].user.username == response.data.username &&
              departmentAccess[0].rol_name != "uploader"
            ) {
              if (department.department_id == loginInfo[0].department.id) {
                currentDepartment = department;
              }
            } else {
              if (departmentAccess[0].rol_name != "uploader") {
                currentDepartment = department;
              }
            }
          });
          commit("setToken", currentDepartment.access_token);
          localStorage.setItem(
            "charlie-otr-token",
            currentDepartment.access_token
          );
          localStorage.setItem(
            "current-department",
            JSON.stringify(currentDepartment)
          );
          let userDepartment = {};
          userDepartment = currentDepartment.department_id;
          localStorage.setItem(
            "charlie-user-department",
            JSON.stringify(response.data.department)
          );
          userInfo = await dispatch("getUsername", userDepartment);
          if (userInfo.status == 200) {
            router.push({
              name: "Emails",
              params: {
                pathName: "queue"
              }
            });
          }
        }
        return [response, userInfo];
      } catch (err) {
        if (err.response.status == 400) {
          swal({
            title: "There is something wrong",
            text: "User or Password incorrect",
            icon: "error",
            dangerMode: true
          });
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return [err.response, null];
      }
    },

    async getUsername({ commit }, userDepartment) {
      try {
        let user = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/user/get-by-username/${userDepartment}/`,
          api.getToken()
        );
        let currentDepartment = JSON.parse(
          localStorage.getItem("current-department")
        );
        if (user.status == 200) {
          for (let infoUser of user.data) {
            if (
              infoUser.rol.name != "uploader" &&
              currentDepartment.department_name == infoUser.department.name &&
              currentDepartment.rol_name == infoUser.rol.name
            ) {
              let userAux = [];
              userAux.push(infoUser);
              localStorage.setItem(
                "charlie-username-otr",
                JSON.stringify(userAux)
              );
              commit("setUserLoggedIn", userAux);
            }
          }
        }
        return user;
      } catch (err) {
        if (err.user.status != 200) {
          errorMessage();
          return err.user;
        }
      }
    },
    async refreshToken({ state, commit }) {
      commit("setRefreshCounter");
      let apiToken = api.getToken();
      try {
        let response;
        if (state.refreshCounter === 1) {
          response = await axios.post(
            process.env.VUE_APP_BACK_ROUTE +
              `/api/auth/refresh-token/?token=${apiToken.headers.token}`
          );
        }
        if (response.status === 200) {
          localStorage.setItem(
            "charlie-user-department",
            JSON.stringify(response.data.department)
          );
          commit("setUserDepartment", response.data.department);
          response.data.department.forEach(element => {
            if (element.department_name === "ltl") {
              localStorage.setItem("charlie-otr-token", element.access_token);
              commit("setToken", element.access_token);
            }
          });
        }
        // dispatch(info.route, info.accountId, { root: true });
        commit("setKeyRefresh");
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
